var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1000px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.orderDatalist
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "detailHead" }, [
                    _c("div", { staticClass: "full" }, [
                      _c("div", { staticClass: "order_icon" }, [
                        _c("span", {
                          staticClass: "iconfont icondingdanguanli",
                        }),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.orderDatalist.orderTypeText || "-")
                          ),
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "mr20" }, [
                            _vm._v(
                              "订单号：" + _vm._s(_vm.orderDatalist.orderId)
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("ul", { staticClass: "list" }, [
                      _vm.orderDatalist.statusStr
                        ? _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("订单状态"),
                            ]),
                            _c("div", { staticClass: "color-warning" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.orderDatalist.statusStr.value)
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("实际支付"),
                        ]),
                        _c("div", [
                          _vm._v(
                            "¥ " + _vm._s(_vm.orderDatalist.payPrice || "0.0")
                          ),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("支付方式"),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm._f("payTypeFilter")(_vm.orderDatalist.payType)
                            )
                          ),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("创建时间"),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.orderDatalist.createTime || "-")),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-tabs",
                    {
                      attrs: { type: "border-card" },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "订单信息", name: "detail" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "detailSection",
                              staticStyle: { border: "none" },
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("用户信息"),
                              ]),
                              _c("ul", { staticClass: "list" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("用户名称："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(_vm.orderDatalist.nikeName) +
                                        " | " +
                                        _vm._s(_vm.orderDatalist.uid)
                                    ),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("用户电话："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(_vm._s(_vm.orderDatalist.phone)),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                          _vm.orderDatalist.shippingType < 2 &&
                          _vm.orderDatalist.secondType !== 2
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("收货信息"),
                                ]),
                                _c("ul", { staticClass: "list" }, [
                                  _c("li", { staticClass: "item" }, [
                                    _c("div", { staticClass: "lang" }, [
                                      _vm._v("收货人："),
                                    ]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.orderDatalist.realName) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("li", { staticClass: "item" }, [
                                    _c("div", { staticClass: "lang" }, [
                                      _vm._v("收货电话："),
                                    ]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.orderDatalist.userPhone) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("li", { staticClass: "item" }, [
                                    _c("div", { staticClass: "lang" }, [
                                      _vm._v("收货地址："),
                                    ]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.orderDatalist.userAddress
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.orderDatalist.shippingType === 2
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("核销信息"),
                                ]),
                                _c("ul", { staticClass: "list" }, [
                                  _c("li", { staticClass: "item" }, [
                                    _c("div", { staticClass: "lang" }, [
                                      _vm._v("核销姓名："),
                                    ]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.orderDatalist.realName) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("li", { staticClass: "item" }, [
                                    _c("div", { staticClass: "lang" }, [
                                      _vm._v("核销电话："),
                                    ]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.orderDatalist.userPhone) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("订单信息"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("商品总价："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDatalist.proTotalPrice)
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("商品总数："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDatalist.totalNum)),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("优惠券："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDatalist.couponPrice)),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("实际支付："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDatalist.payPrice || "0.0")
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("抵扣金额："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDatalist.deductionPrice || "0.0"
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("退款金额："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDatalist.refundPrice || "0.0"
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("支付邮费："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDatalist.payPostage)),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("支付方式："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("payTypeFilter")(
                                        _vm.orderDatalist.payType
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("创建时间："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.createTime
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("推广人："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.spreadName
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("买家留言"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.mark
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("商家备注"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.remark
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm.orderExtend.length
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("自定义留言"),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "list" },
                                  _vm._l(
                                    _vm.orderExtend,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        { key: index, staticClass: "item" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "lang",
                                              attrs: { title: item.title },
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                item.title.includes(":")
                                                  ? ""
                                                  : "："
                                              )
                                            ),
                                          ]),
                                          !Array.isArray(item.value)
                                            ? _c(
                                                "div",
                                                { staticClass: "value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("filterEmpty")(
                                                        item.value
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "flex conter" },
                                                [
                                                  item.value
                                                    ? _vm._l(
                                                        item.value,
                                                        function (pic, idx) {
                                                          return _c(
                                                            "div",
                                                            { key: idx },
                                                            [
                                                              pic.includes(
                                                                "http"
                                                              )
                                                                ? _c(
                                                                    "el-image",
                                                                    {
                                                                      staticClass:
                                                                        "pictrue",
                                                                      attrs: {
                                                                        src: pic,
                                                                        "preview-src-list":
                                                                          [pic],
                                                                      },
                                                                    }
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-14px fontColor333 ml-5px acea-row row-middle mr5",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            pic
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  idx <
                                                                                  item
                                                                                    .value
                                                                                    .length -
                                                                                    1,
                                                                                expression:
                                                                                  "idx < item.value.length - 1",
                                                                              },
                                                                            ],
                                                                          staticStyle:
                                                                            {
                                                                              "margin-left":
                                                                                "6px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "-"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    : [_vm._v(" - ")],
                                                ],
                                                2
                                              ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "tabBox",
                          attrs: { label: "商品信息", name: "goods" },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "mt20 orderDetailList",
                              attrs: {
                                data: _vm.orderDatalist.orderInfo,
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "商品信息",
                                  "min-width": "400",
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "demo-image__preview mr15",
                                                },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      src: scope.row.info.image,
                                                      "preview-src-list": [
                                                        scope.row.info.image,
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "408px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "line1 mb10",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.info
                                                            .productName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "line1 color-909399 line-heightOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "规格：" +
                                                          _vm._s(
                                                            scope.row.info.sku
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2115356876
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "商品售价", "min-width": "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "line1" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.info.price
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3637309700
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "购买数量", "min-width": "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "line1" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.info.payNum
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2773114039
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.orderDatalist.status > 0
                        ? _c(
                            "el-tab-pane",
                            {
                              staticClass: "tabBox",
                              attrs: { label: "发货记录", name: "delivery" },
                            },
                            [
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticClass: "mt20",
                                        attrs: {
                                          size: "small",
                                          data: _vm.orderDatalist.orderInfo,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: { "min-width": "400" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function (scope) {
                                                  return [
                                                    _vm.orderDatalist
                                                      .deliveryType ===
                                                    "express"
                                                      ? [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-color",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "【快递配送】"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .orderDatalist
                                                                  .deliveryName +
                                                                  "：" +
                                                                  _vm
                                                                    .orderDatalist
                                                                    .deliveryId
                                                              )
                                                            ),
                                                          ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ml30",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .orderDatalist
                                                                    .createTime
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm.orderDatalist
                                                          .deliveryType ===
                                                        "send"
                                                      ? [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-color",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "【商家送货】"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .orderDatalist
                                                                  .deliveryName +
                                                                  "：" +
                                                                  _vm
                                                                    .orderDatalist
                                                                    .deliveryId
                                                              )
                                                            ),
                                                          ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ml30",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .orderDatalist
                                                                    .createTime
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-color",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "【虚拟发货】"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ml30",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .orderDatalist
                                                                    .createTime
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                  ]
                                                },
                                              },
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "acea-row row-middle",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "demo-image__preview mr15",
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              attrs: {
                                                                src: scope.row
                                                                  .info.image,
                                                                "preview-src-list":
                                                                  [
                                                                    scope.row
                                                                      .info
                                                                      .image,
                                                                  ],
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "408px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "line1 mb10 line-heightOne",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .info
                                                                      .productName
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "line1 color-909399 line-heightOne",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "规格：" +
                                                                    _vm._s(
                                                                      scope.row
                                                                        .info
                                                                        .sku
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "acea-row row-middle ml30",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "line1 font12 color-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "X " +
                                                                    _vm._s(
                                                                      scope.row
                                                                        .info
                                                                        .payNum
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2216272556
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "400",
                                            fixed: "right",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mr10",
                                                        staticStyle: {
                                                          "justify-content":
                                                            "flex-end",
                                                        },
                                                      },
                                                      [
                                                        _vm.orderDatalist
                                                          .deliveryType ===
                                                        "express"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.openLogistics(
                                                                        _vm
                                                                          .orderDatalist
                                                                          .orderId,
                                                                        _vm
                                                                          .orderDatalist
                                                                          .deliveryName
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看物流 "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return _vm.orderDatalist
                                                    .deliveryType === "noNeed"
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "acea-row row-middle",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "font12 color-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "发货备注：" +
                                                                    _vm._s(
                                                                      _vm
                                                                        .orderDatalist
                                                                        .deliveryMark
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : undefined
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.orderDatalist
        ? _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.modal2, width: "30%" },
              on: {
                "update:visible": function ($event) {
                  _vm.modal2 = $event
                },
              },
            },
            [
              _c("div", { staticClass: "logistics acea-row row-top" }, [
                _c("div", { staticClass: "logistics_img" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/imgs/expressi.jpg") },
                  }),
                ]),
                _c("div", { staticClass: "logistics_cent" }, [
                  _c("span", { staticClass: "mb10" }, [
                    _vm._v(
                      "物流公司：" + _vm._s(_vm.orderDatalist.deliveryName)
                    ),
                  ]),
                  _c("span", [
                    _vm._v("物流单号：" + _vm._s(_vm.orderDatalist.deliveryId)),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "acea-row row-column-around trees-coadd" },
                [
                  _c(
                    "div",
                    { staticClass: "scollhide" },
                    [
                      _c(
                        "el-timeline",
                        { attrs: { reverse: _vm.reverse } },
                        _vm._l(_vm.result, function (item, i) {
                          return _c("el-timeline-item", { key: i }, [
                            _c("p", {
                              staticClass: "time",
                              domProps: { textContent: _vm._s(item.time) },
                            }),
                            _c("p", {
                              staticClass: "content",
                              domProps: { textContent: _vm._s(item.status) },
                            }),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.modal2 = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.modal2 = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }